exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".MonthZhiChi .kaoheForm {\n  display: flex;\n  margin: 10px 0;\n  padding: 0 10px;\n}\n.MonthZhiChi .kaoheForm .item {\n  padding: 0 5px;\n  display: flex;\n}\n.MonthZhiChi .kaoheForm .item label {\n  display: inline-block;\n  vertical-align: middle;\n  white-space: nowrap;\n  line-height: 26px;\n}\n.MonthZhiChi .kaoheForm .item input {\n  height: 26px;\n  padding: 0 5px;\n  margin-left: 3px;\n}\n.MonthZhiChi .kaoheForm .item input[disabled] {\n  background-color: #f4f4f4;\n  border: 1px solid #d8d8d8;\n}\n", ""]);

// exports
